import React, { useEffect, useRef, useState } from "react";
import styles from "./Tooltip.module.scss";

const Tooltip = ({ text }) => {
  const ellipses = useRef();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (ellipses && ellipses.current) {
      //to check if ellipses are added or not
      setShow(ellipses.current.scrollHeight > ellipses.current.clientHeight+2);
    }
  }, []);

  return (
    <div tabIndex={0} className={` ${styles.tooltip}`}>
      <div ref={ellipses} className={`${styles.ellipses} `}>
        {text}
      </div>
        {show && <div className={`xx-small ${styles.tooltiptext}`}>{text}</div>}
    </div>
  );
};

export default Tooltip;
